import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link, useNavigate } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
// import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";

export default function FaqListPage() {
    const [faqs, setFaqs] = useState([]);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get("/admin/faqs").then(res => setFaqs(res.data));
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Nonaktifkan FAQ ini?")) {
            await axios.delete(`/admin/faqs/${id}`);
            setFaqs(faqs.map(f => f.id === id ? { ...f, is_active: false } : f));
        }
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Daftar FAQ</h4>
            </div>
            <div className="card-body">
                <Link to="/admin/faqs/create" className="btn btn-success mb-3">Tambah FAQ</Link>
                <ErrorModal error={error} onClose={() => setError("")} />
                <SuccessModal
                    message={success}
                    onClose={() => {
                        setSuccess("");
                        navigate("/admin/faqs");
                    }}
                />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Pertanyaan</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {faqs.map(f => (
                            <tr key={f.id}>
                                <td>{f.question}</td>
                                <td>{f.is_active ? "Aktif" : "Nonaktif"}</td>
                                <td>
                                    <Link to={`/admin/faqs/${f.id}/edit`} className="btn btn-sm btn-warning">Edit</Link>{" "}
                                    {f.is_active && (
                                        <button onClick={() => handleDelete(f.id)} className="btn btn-sm btn-danger">Nonaktifkan</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
